
/* injects from baggage-loader */

import {connect} from 'react-redux'
import {IntlProvider} from 'react-intl'

const mapStateToProps = state => {
  return {locale: 'en'}
}

export default connect(mapStateToProps)(IntlProvider)



// WEBPACK FOOTER //
// ./client/containers/IntlContainer/index.js